import React from "react";

import { CSpinner } from "@coreui/react";

import { PAGE_LOADER_CONSTANTS } from "../../constants/pageLoaderConstants";
import { PageLoaderProps } from "../../models/page.loader.model";
const PageLoader: React.FC<PageLoaderProps> = (props: PageLoaderProps) => {
  const showContent: boolean =
    (typeof props?.overlayOnly !== PAGE_LOADER_CONSTANTS.OVERLAY_TYPE &&
      props?.overlayOnly === false) ||
    typeof props?.overlayOnly === PAGE_LOADER_CONSTANTS.OVERLAY_TYPE;

  return (
    <div className={`dd-page-loader ${!props.isLoading && "d-none"}`}>
      <div className="text-center">
        {showContent && (
          <>
            <CSpinner color="danger"></CSpinner>
            <div className="dd-text dd-bg-coffee dd-text-white py-1 px-3 rounded">
              Loading...
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PageLoader;
